import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@elka/theme';
import { ErrorBoundary } from '@elka/layout';
import App from './App';
import './index.css';
import './lib/firebase/config';
import { registerServiceWorker } from './lib/pwa/register';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider storageKey="team-theme" defaultTheme="elkaBlue">
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);

registerServiceWorker();
